import { render } from "./BrandLogo.vue?vue&type=template&id=47244ffa"
import script from "./BrandLogo.vue?vue&type=script&lang=js"
export * from "./BrandLogo.vue?vue&type=script&lang=js"
script.render = render

export default script